module.exports = "  \n<h1>DAMS-NT Videos</h1>\n<p>Videos showing how to use the DAMS-NT system will be included in a future release.</p>\n"